// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1iHrw","name":"Header_name__WnJyL","birthday":"Header_birthday__23Q_L","skeleton":"Header_skeleton__14AAF"};